<template>
  <div>
    <Pie3d :chartData="chartData" />
  </div>
</template>

<script>
import Pie3d from "@/components/Highcharts/Pie3d.vue";

export default {
  name: "JiudianZiyuanFenxi",
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    Pie3d
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
